import styled from 'styled-components'
import breakpoint from '@/client/components/theme/breakpoint'
import color from '@/client/components/theme/color'
import space from '@/client/components/theme/space'

export const Featured = styled.div``

export const MainFeatured = styled.div`
  margin-top: ${space.xl4};
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  & img {
    order: 1;
    width: auto;
  }

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;

    & img {
      order: 2;
    }
  }

  @media (min-width: ${breakpoint.xl}) {
    & img {
      width: 400px;
    }
  }
`

export const Container = styled.div`
  width: 100%;
  order: 2;
  margin-top: ${space.lg};

  @media (min-width: ${breakpoint.lg}) {
    order: 1;
    width: 50%;
    margin-top: 0;
  }
`

export const SearchBox = styled.div`
  width: 100%;
  background-color: ${color.grayscale.lighter};
  border-radius: ${space.md};
  padding: ${space.md};

  .search_input {
    padding-bottom: ${space.md};
    width: 100%;

    .basic-input-element {
      padding-left: ${space.md};
    }
  }

  @media (min-width: ${breakpoint.lg}) {
    width: 90%;
  }

  @media (min-width: ${breakpoint.xl2}) {
    width: 100%;
  }
`
